import { lazy } from 'react';
import { useModal } from '../../../../components/modal';

import { Transcription } from '../../../../@types/notes-transcription';

const Component = lazy(() =>
  import('./TranscriptionModal').then((module) => ({
    default: module.TranscriptionModal,
  })),
);

export const useNotesTranscriptionModal = () => {
  const { hideModal, showModal } = useModal(Component, []);

  return {
    hideNotesTranscriptionModal: hideModal,
    showNotesTranscriptionModal: (data: {
      transcription: Transcription;
      channelId: string;
      noteId: string;
    }) => showModal(data),
  };
};
